import type { ReactNode } from 'react'
import React from 'react'
import { HorizontalStack, Icon, ShowIf, Status } from '@ztechapps/webui.util'
import { truncate } from '@ztechapps/common.utils'
import { MessageTimeStamp } from '../Chat/ChatMessages/MessageTimeStamp'
import type { RecentMessageListRowProps } from '../RecentMessage'
import { Stack } from 'react-bootstrap'

export const ChatMessageWidget = ({
  isPublic = true,
  isUnread,
  orderId,
  isSelected,
  sender,
  chat,
  timeStamp,
  message,
  actionComponent,
}: RecentMessageListRowProps & { actionComponent: ReactNode }) => {
  const subject = chat?.subject
  const email = sender?.profile?.email

  return (
    <Stack gap={2} className={`${isUnread ? 'font-bold' : ''}`}>
      <HorizontalStack className={'justify-content-between border-bottom'}>
        <HorizontalStack gap={1} className="align-items-center">
          <div>
            <Status type={orderId ? 'info' : 'warning'} />
          </div>
          <div className={'mr-2'}>{email}</div>
        </HorizontalStack>
        <div>
          <MessageTimeStamp value={timeStamp} />
        </div>
      </HorizontalStack>

      <div>
        <div>
          <div className={'fw-bold'}>{truncate(subject, 100)}</div>
          <small>
            <ShowIf condition={isPublic === false}>
              <Icon name={'eye-slash'} title={'private message'} className={'me-2'} />
            </ShowIf>
            {truncate(message, 100)}
          </small>
        </div>
      </div>

      <div>
        <ShowIf condition={!!isSelected && !!actionComponent}>{actionComponent}</ShowIf>
      </div>
    </Stack>
  )
}
